import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'
import { TagTypes } from '../reducers/tagReducer'

export function* fetchTags() {
  try {
    const tagRef = firebase.database().ref('tags')
    const response = yield call([tagRef, tagRef.once], 'value')

    if (response.val() !== null) {
      yield put({ type: TagTypes.FETCH_TAGS_SUCCESS, data: response.val() })
    } else {
      yield put({ type: TagTypes.FETCH_TAGS_ERROR, error: 'null' })
    }
  } catch (error) {
    yield put({ type: TagTypes.FETCH_TAGS_ERROR, error })
  }
}



// WEBPACK FOOTER //
// ./src/sagas/tagSaga.js